import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { GroupEntity } from '@backstage/catalog-model';
import { isGroupEntity } from '@backstage/catalog-model';
import { mapGroupEntitiesToTeams } from './teamUtils';
import { Team } from '@internal/schemas-common';
import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import { useLogger } from '../../utils/logger';
import { useMemo } from 'react';
import { useUserProfile } from '@backstage/plugin-user-settings';

export function useUserTeams(): { teams: Team[], isLoading: boolean } {
  const { backstageIdentity } = useUserProfile();
  const catalogApi = useApi(catalogApiRef);
  const logger = useLogger();

  const { value: groupEntities, loading: isLoading } = useAsync(async () => {
    const refs = backstageIdentity?.ownershipEntityRefs ?? [];
    if (!refs.length) return [];

    const { items } = await catalogApi.getEntitiesByRefs({
      entityRefs: refs,
    });

    return items
      ? items.filter((item): item is GroupEntity => !!item && isGroupEntity(item))
      : [];
  }, [backstageIdentity, catalogApi]);

  const teams = useMemo(() => mapGroupEntitiesToTeams(groupEntities, logger),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [groupEntities]
  );

  return { teams, isLoading };
}
